// extracted by mini-css-extract-plugin
export default {"main":"_90fd9e0ce3 c2c39ac8ae","xmark":"_5304442fe3","fl_img":"_6797a30431 _894ee89bd5"};